import React from "react";
import { Box, Heading, Text, Container, VStack } from "@chakra-ui/react";
import Navbar from "../components/common/Navbar";
import Footer from "../components/common/Footer";

export default function Test() {
  return (
    <Box>
      <Navbar />

      <Container maxW="container.xl" py={20}>
        <VStack spacing={8} align="start">
          <Box>
            <Heading size="xl" mb={2}>
              Test Page - Theme Check
            </Heading>
            <Text>If you can see this text, the theme is working!</Text>
          </Box>

          <Box bg="brand.50" p={4} borderRadius="md" w="full">
            <Heading size="md" color="brand.800" mb={2}>
              Brand Colors Test
            </Heading>
            <Text color="brand.700">Light brand color</Text>
          </Box>

          <Box bg="brand.800" p={4} borderRadius="md" w="full" color="white">
            <Heading size="md" mb={2}>
              Dark Background
            </Heading>
            <Text>White text on dark background</Text>
          </Box>

          <Box bg="accent.green" p={4} borderRadius="md" w="full" color="white">
            <Heading size="md" mb={2}>
              Accent Green
            </Heading>
            <Text>This is the accent green color</Text>
          </Box>

          <Box>
            <Heading size="sm" color="accent.green">
              Accent Green Heading
            </Heading>
          </Box>

          <Text>
            If all boxes above display with correct colors, the theme is working properly!
          </Text>
        </VStack>
      </Container>

      <Footer />
    </Box>
  );
}
